
export const mountDashboardAreas = (summary: any) => {
    return {
        globalInterests: summary.interestGlobal,
        opcionalInterests: summary.interestOptional,
        globalAvoids: summary.avoidGlobal,
        optinalAvoids: summary.avoidOptional,
    };
}

